import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { getDateAsUTC, ToastService } from 'src/app/core';
import {
    CandidateApi, CandidateGridInfo,
    ImmigrationApi,
    ImmigrationProfile, LookupApi,
    LookupField,
    SortParameters
} from 'src/app/core/api.gen';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/core/common.service';
import { CSVReportService } from 'src/app/core/csvreport.service';
import { FilterBase } from 'src/app/immigration/services/filters/filter-base';
import { IColumnHeader } from 'src/app/immigration/services/Immigration-profile-list';
import { checkAcess } from 'src/app/immigration/services/manage-access/profile-access-rights';
import { isNullOrUndefined } from '../../../app/core/utils';
import { ImmigrationStatusTypes } from '../immigration-status-types';
import { LoaderService } from 'src/app/core/loader.service';
import { Router } from '@angular/router';
import { BusinessTravel } from 'src/app/immigration/services/visatypes/country-types.enum';

@Component({
  selector: 'eos-immigration-grid',
  templateUrl: './immigration-grid.component.html',
  styleUrls: ['./immigration-grid.component.css']
})
export class ImmigrationGridComponent implements OnInit, OnChanges {

  // data Models
  @ViewChild('rangePicker') rangePicker;
  @Input() data: CandidateGridInfo;
  @Output() deleteEvent = new EventEmitter<ImmigrationProfile>();
  @Output() withdrawEvent = new EventEmitter<ImmigrationProfile>();
  @Output() viewMilesEvent= new EventEmitter<ImmigrationProfile>();
  
  @Output() copyEvent = new EventEmitter<ImmigrationProfile>();
  @Input() countryType: string;
  @Input() visaType: string;
  @Input() isApprover: boolean;
  @Input() columnHeaders: IColumnHeader[];
  @Input() filters: FilterBase[] = [];
  @Input() filterForm: UntypedFormGroup;
  @Input() viewActivity: boolean;
  @Input() viewDelete: boolean;
  @Input() visaObj: LookupField;

  @Output() filterEvent = new EventEmitter<SortParameters>();
  ImmigrationStatusTypes = ImmigrationStatusTypes
  // Pagination
  currentPage: number;
  totalRecords: number;
  totalPages: number;
  changeCount: number[] = [10, 15, 25, 50, 75];
  pages: number[] = [];
  tableLoading = true;
  pageNumber = 1;
  isVisaApprover = true;
  isAdminEditProfileRole = false;
  disableDownload = false;
  disableControl = false;
  dateRange: Date[];
  maxDate = new Date();
  isDateRangeSelected = false;
  isAllRequest = false;
  redirectUrl: string;
  visaName: string;
  ActiveUserEmpId = 0;
  locationWiseAccess = false;
  constructor(
    private immigrationService: ImmigrationApi,
    private toast: ToastService,
    private router: Router,
    private loader: LoaderService,
    private lookUpService: LookupApi,
    private common: CommonService,
    private csvreportService: CSVReportService,
    private authService: AuthService,
    private candidateService: CandidateApi,
    private datePipe: DatePipe
  ) {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    this.dateRange = [d, this.maxDate];
    this.ActiveUserEmpId = this.authService.ActiveUser.employeeId;
  }

  ngOnChanges() {
    this.gridConfigure();
  }

  ngOnInit() {
    // this.lookUpService.getServiceLines(undefined, undefined).subscribe(resp => {
    //   this.serviceLines = resp;
    // });
    this.immigrationService.checkVisaApproverAccess(this.countryType).subscribe(resp => {
      this.locationWiseAccess = resp;
    });
    this.isVisaApprover = this.common.isVisaApprover;
    this.isAdminEditProfileRole = this.common.isAdminProfileEdit;
    if (this.isVisaApprover || this.authService.ActiveUser.features.includes('CanEdit-PTC')) {
      this.disableControl = true;
    }
    if (!this.visaType) {
      this.isAllRequest = true;
    }    
    if(!this.isAllRequest)
    {
      this.visaName = this.visaObj.displayText;
    }
   
  }

  get enableReport() {
    let immReportDownloadClaim = `${this.countryType}-${this.visaType}-CanDownloadReport`;
    return (this.isVisaApprover && this.locationWiseAccess) || this.authService.hasClaim('AllVisaView') || this.authService.hasClaim('IMM_Report_Downlaod') || this.authService.hasClaim(immReportDownloadClaim);
  }

  onDateRangePickerShow() {
    if (!this.isDateRangeSelected) {
      const currDate = new Date();
      currDate.setMonth(currDate.getMonth());
      this.rangePicker._datepicker.instance.monthSelectHandler({ date: currDate });
    }

  }
  onValueChange(value: Date) {
    if (value !== null) {
      if (value[0] !== this.dateRange[0] && value[1] !== this.dateRange[1]) {
        this.isDateRangeSelected = true;
      }
    }
  }

  gridConfigure() {
    this.currentPage = this.data.sortParameters ? this.data.sortParameters.page : 1;
    this.totalRecords = this.data.sortParameters ? this.data.sortParameters.totalRecords : 0;

    this.numberOfPages();
    this.pageGenerate();

    if (!isNullOrUndefined(this.data.immigrationProfiles)) {
      if (this.data.immigrationProfiles.length) {
        this.tableLoading = false;
      } else {
        this.tableLoading = null;
      }
    }

  }
  viewAction(pbp: ImmigrationProfile) {
    if (!this.isVisaApprover) {
      return false;
    } else {
      if (!checkAcess(pbp, this.authService.ActiveUser, this.isVisaApprover, this.countryType)) {
        return false;
      } else {
        return true;
      }
    }
  }
  

  filter() {
    this.mapToFilterParams();
    this.data.sortParameters.page = 1;
    this.totalPages = 0;
    this.data.sortParameters.tileRefreshNeeded = true;
    this.data.sortParameters.filterParams.onTileClick = false;
  }



  report() {
   
    const filters = this.filterForm.getRawValue();
    this.data.sortParameters.filterParams.submissionstartDate = getDateAsUTC(filters.submissionstartDate);
    this.data.sortParameters.filterParams.submissionendDate = getDateAsUTC(filters.submissionendDate);
    this.data.sortParameters.filterParams.visaCountry = this.countryType;
   
    if (this.tableLoading == null) {
      if (this.countryType == BusinessTravel.Value) {
        this.toast.warning("No Business Travel profiles Exists");
      } else {
        this.toast.warning("No Immigration profiles Exists");
      }
      return;
    }
    //this.disableDownload = true;
    let visa = this.visaType;
    if (this.isAllRequest) {
      visa = "AllVisa";
      this.data.sortParameters.filterParams.isAllVisa = true;
    }
    this.toast.successImmReports('A request for the report has been placed. Please wait till you receive it in your mailbox.');

    this.csvreportService.downloadImmreport(visa, this.data.sortParameters.filterParams)
      .pipe(finalize(() => {
       // this.disableDownload = false;
      })).subscribe(resp => 
        {
      //   let fileName = `${this.visaName} report (${this.countryType}) - ${this.datePipe.transform(new Date(), 'dd.MM.YY - hh.mm a')}.xlsx`;
      //   if (this.isAllRequest) {
      //     fileName = `All visa report (${this.countryType}) - ${this.datePipe.transform(new Date(), 'dd.MM.YY - hh.mm a')}.xlsx`;
      //   }
      //   if (window.navigator.msSaveOrOpenBlob) {
      //     window.navigator.msSaveBlob(resp, fileName);
      //   } else {
      //     const url = window.URL.createObjectURL(resp);
      //     const a = document.createElement("a");
      //     document.body.appendChild(a);
      //     a.setAttribute("style", "display: none");
      //     a.href = url;
      //     a.download = fileName;
      //     a.click();
      //     window.URL.revokeObjectURL(url);
      //     a.remove();
      //   }
      // });
      // if(!resp){
      //       this.toast.error('Error occured during report extraction');
      //     }
      });
  }


  filterGridConfigure() {
    this.pageNumber = 1;
    this.currentPage = 1;

    this.pages = [];
    for (let i = 0; i < (this.totalPages > 5 ? 5 : this.totalPages); i++) {
      this.pages.push(i);
    }
  }

  numberOfPages() {
    this.totalPages = this.data.sortParameters ?
      Math.ceil(this.data.sortParameters.totalRecords / this.data.sortParameters.itemsPerPage) : 0;

    return this.totalPages;
  }

  pageGenerate() {
    this.pages = [];

    for (let i = 0; i < (this.totalPages > 5 ? 5 : this.totalPages); i++) {
      this.pages.push(i);
    }

    if (this.totalPages <= 5) {
      this.pageNumber = 1;
    } else if (this.currentPage - 4 > 0) {
      this.pageNumber = this.currentPage - 4;
    }
  }



  onSelectChanges() {
    if (this.currentPage > this.numberOfPages()) {
      this.data.sortParameters.page = this.numberOfPages();
    }
    this.data.sortParameters.tileRefreshNeeded = false;
    this.reloadData();
  }

  sort(reverse: boolean, prop: string) {
    this.data.sortParameters.reverse = reverse;
    this.data.sortParameters.sortBy = prop;
    this.data.sortParameters.tileRefreshNeeded = false;
    this.reloadData();
  }

  pageChange(page: number) {

    if (page > this.totalPages || page <= 0) {
      this.pageNumber = page > this.totalPages ? this.totalPages : 1;
      return;
    }

    if ((page === this.pageNumber + 4) && !((page + 4) > this.totalPages)) {
      this.pageNumber = this.pageNumber + 4;
    } else if ((page === this.pageNumber) && (page - 4) > 0) {
      this.pageNumber = this.pageNumber - 4;
    } else if ((page === this.pageNumber + 4) && ((page + 4) > this.totalPages)) {
      this.pageNumber = this.pageNumber + (this.totalPages - page);
    } else if ((page === this.pageNumber) && (page - 4) < 1) {
      this.pageNumber = 1;
    } else if ((page < this.pageNumber) && (this.pageNumber - 4) > 0) {
      this.pageNumber = this.pageNumber - 4;
    } else if ((page > this.pageNumber + 4) && (page + 4) <= this.totalPages) {
      this.pageNumber = page;
    } else if ((page > this.pageNumber + 4) && (page + 4) > this.totalPages) {
      this.pageNumber = page - ((page + 4) - this.totalPages);
    }

    if (page === 1) {
      this.pageNumber = 1;
    }

    this.data.sortParameters.page = page;
    this.currentPage = this.data.sortParameters.page;
    this.data.sortParameters.tileRefreshNeeded = false;
    this.reloadData();
  }


  deleteCandidate(candidate: ImmigrationProfile) {
    this.deleteEvent.emit(candidate);
  }
  withdrawCandidate(candidate: ImmigrationProfile) {
    this.withdrawEvent.emit(candidate);
  }
  viewMilestone(candidate: ImmigrationProfile) {
    this.viewMilesEvent.emit(candidate);
  }
  copyCandidate(candidate: ImmigrationProfile) {
    this.copyEvent.emit(candidate);
  }
  // activityReset(immigrationProfile: ImmigrationProfile){
  //   this.loader.show();
  //   this.immigrationService.resetActivities(immigrationProfile).pipe(finalize(() => {
  //     this.loader.clear();
  //   })).subscribe(resp => {
  //     if(resp.data>0){
  //       this.router.navigateByUrl(`immigration/activities/${this.countryType}/${immigrationProfile.visaType.value}/${resp.data}`);
  //     }
  //     else{
  //       this.toast.warning("Error occured.");
  //     }
  //   });
  // }
  getActivityRedirectUrl(immigrationProfile: ImmigrationProfile) {
    switch (immigrationProfile.status.value) {
      case ImmigrationStatusTypes.DRAFT:
        break;
      default:
        // tslint:disable-next-line:max-line-length
        this.common.isAllVisaRequest.next(this.isAllRequest);
        this.redirectUrl = "/immigration/activities/" + this.countryType + "/" + immigrationProfile.visaType.value + "/" + immigrationProfile.id;
        break;
    }
    return this.redirectUrl;
  }

  clear() {
    this.filterForm.reset();
    this.gridConfigure();
    this.filter();
  }

  mapToFilterParams() {
    const filters = this.filterForm.getRawValue();
    this.data.sortParameters.filterParams.consultantId = filters.consultantId;
    this.data.sortParameters.filterParams.firstName = filters.firstName;
    this.data.sortParameters.filterParams.lastName = filters.lastName;
    this.data.sortParameters.filterParams.servicLineId = filters.servicLineId;
    this.data.sortParameters.filterParams.locationId = filters.locationId;
    this.data.sortParameters.filterParams.ptcId = filters.ptcId;
    this.data.sortParameters.filterParams.recruiterId = filters.recruiterId;
    this.data.sortParameters.filterParams.statusId = filters.statusId;
    this.data.sortParameters.filterParams.visaTypeId = filters.visaTypeId;
    this.data.sortParameters.filterParams.immigrationStatus = filters.immigrationStatus;
    this.data.sortParameters.filterParams.subServiceLineIds = filters.subServiceLineIds;
    this.data.sortParameters.filterParams.legalEntityId = filters.legalEntityId;
    this.data.sortParameters.filterParams.submissionstartDate = getDateAsUTC(filters.submissionstartDate);
    this.data.sortParameters.filterParams.submissionendDate = getDateAsUTC(filters.submissionendDate);
    this.data.sortParameters.filterParams.officeLocationId = filters.officeLocationId;
    this.data.sortParameters.filterParams.officeToBeVisitedId = filters.officeToBeVisitedId; 
    this.data.sortParameters.filterParams.employeeEmailId = filters.employeeEmailId;
    this.data.sortParameters.filterParams.countryId = filters.countryId;
    const moduleName = this.visaType ? `${this.countryType}${this.visaType}` : `${this.countryType}Imm`;
    this.candidateService.saveFilterParams(moduleName.toLocaleLowerCase(), this.data.sortParameters.filterParams).subscribe(res => {
      this.data.sortParameters.tileRefreshNeeded = true;
      this.reloadData();
    });
  }

  reloadData(): void {
    this.filterEvent.emit(this.data.sortParameters);
  }

  getRedirectUrl(profile: ImmigrationProfile) {
   
    switch (profile.status.value) {
      // case ImmigrationStatusTypes.DRAFT:
      // case ImmigrationStatusTypes.DECLINED:
      //   this.router.navigateByUrl(`/immigration/visa/${this.country}/${profile.visaType.value}/${profile.id}`);
      //   break;
    

      case ImmigrationStatusTypes.PENDING:
       
          if (this.isVisaApprover && checkAcess(profile, this.authService.ActiveUser, this.isVisaApprover, this.countryType)) {
            this.redirectUrl = "/immigration/accept/" + this.countryType + "/" + profile.visaType.value + "/" + profile.id;
          } else {
            this.redirectUrl = "/immigration/visa/" + this.countryType + "/" + profile.visaType.value + "/" + profile.id;
          }
        
        break;
      case ImmigrationStatusTypes.ACCEPTED:
      case ImmigrationStatusTypes.INPROCESS:
      case ImmigrationStatusTypes.APPROVED:
      case ImmigrationStatusTypes.REJECTED:
      case ImmigrationStatusTypes.ONHOLD:
      case ImmigrationStatusTypes.COMPLETED:

        if (this.isVisaApprover && checkAcess(profile, this.authService.ActiveUser, this.isVisaApprover, this.countryType)) {
            this.redirectUrl = "/immigration/approve/" + this.countryType + "/" + profile.visaType.value + "/" + profile.id;
          }
          else if(this.isAdminEditProfileRole){
            this.redirectUrl = "/immigration/approve/" + this.countryType + "/" + profile.visaType.value + "/" + profile.id;
          }
          else {
            this.redirectUrl = "/immigration/visa/" + this.countryType + "/" + profile.visaType.value + "/" + profile.id;
          }
       
        break;

      case ImmigrationStatusTypes.DECLINED:
        this.redirectUrl = "/immigration/visa/" + this.countryType + "/" + profile.visaType.value + "/" + profile.id;
        break;
      default:
        // if (this.isVisaApprover) {
        // this.router.navigateByUrl(`/immigration/requests/${this.country}/${profile.visaType.value}/${profile.id}`);
        // } else {
        this.redirectUrl = "/immigration/visa/" + this.countryType + "/" + profile.visaType.value + "/" + profile.id;
        // }
        break;
    }
    return this.redirectUrl;
  }
}

